import type NonEmptyText from './non-empty-text';
import type { IPositionInit } from './position';
import type PositiveInteger from './positive-integer';
import { assertIsInstanceOfNonEmptyText, assertIsInstanceOfPositiveInteger } from './assertions';
import Position from './position';

interface IModelPosition extends IModelPositionInit {}

interface IModelPositionInit extends IPositionInit {
	readonly height: PositiveInteger;
	readonly model: NonEmptyText;
	readonly width: PositiveInteger;
}

export default class ModelPosition extends Position implements IModelPosition {
	public get height(): PositiveInteger {
		return this.#height;
	}

	public get model(): NonEmptyText {
		return this.#model;
	}

	public get width(): PositiveInteger {
		return this.#width;
	}

	#height: PositiveInteger;
	#model: NonEmptyText;
	#width: PositiveInteger;

	public constructor({ description, height, index, litra, model, note, parent, price, quantity, width }: IModelPositionInit) {
		super({ description, index, litra, note, parent, price, quantity });
		assertIsInstanceOfPositiveInteger(height);
		this.#height = height;
		assertIsInstanceOfNonEmptyText(model);
		this.#model = model;
		assertIsInstanceOfPositiveInteger(width);
		this.#width = width;
	}
}
